export default "__VITE_ASSET__fff12d75__"